// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_w37","cls2":"YourPaperCard-cls2_iMM YourPaperCard-cls1_w37"};